// read only atm, no need for mobx
class CustomerPayment {
  /**
   * @property {number}
   */
  customerPaymentId;

  /**
   * @property {number}
   */
  customerId;

  /**
   * @property {number}
   */
  tourId;

  /**
   * @property {number}
   */
  productId;

  /**
   * @property {string}
   */
  creationDts;

  /**
   * @property {string}
   */
  paidDts;

  /**
   * @property {string}
   */
  canceledDts;

  /**
   * @property {string}
   */
  amount;

  /**
   * @property {currency}
   */
  currency;

  /**
   * @property {string}
   */
  description;

  /**
   * @property {string}
   */
  type;

  /**
   * @property {string}
   */
  customerProductName;

  constructor({
    customerPaymentId = null,
    customerId = null,
    tourId = null,
    productId = null,
    creationDts = null,
    paidDts = null,
    canceledDts = null,
    amount = "",
    currency = "",
    description = "",
    type = "",
    customerProductName = "",
  }) {
    this.customerPaymentId = customerPaymentId;
    this.customerId = customerId;
    this.tourId = tourId;
    this.productId = productId;
    this.creationDts = creationDts;
    this.paidDts = paidDts;
    this.canceledDts = canceledDts;
    this.amount = amount;
    this.currency = currency;
    this.description = description;
    this.type = type;
    this.customerProductName = customerProductName;
  }
}

export default CustomerPayment;
